<script lang="ts">
  import { Link, navigate } from 'svelte-routing';
  import { api } from '../../lib/api/client';
  import { isAuthenticated } from '../../lib/stores/auth';
  import PageHeader from '../../lib/components/PageHeader.svelte';
  import { activityIcon, clockTime, length } from '../../lib/utils/activities';
  import { calendar, count, hours, monthAfter, monthBefore, monthName, type MonthData } from '../../lib/utils/insights';
  import { sportOf } from '../../lib/utils/sports';
  import { integer, t } from '../../lib/i18n/index.ts';

  // Recap is a month in numbers (spec 006 FR-072): its activities, time,
  // distance, days active, most recorded sport, and longest activity, with
  // the months before and after.
  let { month }: { month: string } = $props();

  let m = $state<MonthData | null>(null);
  let error = $state('');
  const thisMonth = new Date().toLocaleDateString('en-CA').slice(0, 7);

  $effect(() => {
    if (!$isAuthenticated) navigate('/login', { replace: true });
  });

  $effect(() => {
    const at = month;
    m = null;
    api.get<MonthData>(`/me/months?month=${at}&${calendar()}`)
      .then((got) => { m = got; error = ''; })
      .catch((e) => (error = e.message));
  });
</script>

<div class="p-6 max-w-3xl w-full mx-auto space-y-4">
  <Link to="/activities/progress" class="text-sm hover:opacity-80"><i aria-hidden="true" class="las la-arrow-left mr-1"></i>{t('activitiesProgress')}</Link>
  <PageHeader title={t('activitiesRecapTitle', { month: monthName(month) })} />
  <div class="flex gap-2">
    <Link to="/activities/recap/{monthBefore(month)}" class="btn btn-secondary btn-sm"><i aria-hidden="true" class="las la-chevron-left mr-1"></i>{monthName(monthBefore(month))}</Link>
    {#if monthAfter(month) <= thisMonth}
      <Link to="/activities/recap/{monthAfter(month)}" class="btn btn-secondary btn-sm">{monthName(monthAfter(month))}<i aria-hidden="true" class="las la-chevron-right ml-1"></i></Link>
    {/if}
  </div>
  {#if error}
    <p class="text-sm" style="color: var(--theme-error);">{error}</p>
  {/if}
  {#if m}
    {#if m.recap.count === 0}
      <p>{t('activitiesRecapNone', { month: monthName(month) })}</p>
    {:else}
      <dl class="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div><dt class="text-xs text-text-muted">{t('activitiesRecapCount')}</dt><dd class="text-2xl">{count(m.recap.count)}</dd></div>
        <div><dt class="text-xs text-text-muted">{t('activitiesStatMovingTime')}</dt><dd class="text-2xl">{hours(m.recap.moving_s)}</dd></div>
        <div><dt class="text-xs text-text-muted">{t('activitiesStatDistance')}</dt><dd class="text-2xl">{length(m.recap.distance_m)}</dd></div>
        <div><dt class="text-xs text-text-muted">{t('activitiesRecapDaysActive')}</dt><dd class="text-2xl">{integer(m.recap.days_active)}</dd></div>
        {#if m.recap.top_sport}
          <div><dt class="text-xs text-text-muted">{t('activitiesRecapTopSport')}</dt><dd class="text-2xl"><i aria-hidden="true" class="las la-{sportOf(m.recap.top_sport).icon} mr-1"></i>{sportOf(m.recap.top_sport).name}</dd></div>
        {/if}
      </dl>
      {#if m.recap.longest}
        {@const a = m.recap.longest}
        <h2 class="font-semibold">{t('activitiesRecapLongest')}</h2>
        <Link to="/activity/{a.id}" class="card block p-3 hover:opacity-80">
          <span class="block font-medium"><i aria-hidden="true" class="las {activityIcon(a.type)} mr-1"></i>{a.name}</span>
          <span class="block text-sm">{[a.gps ? length(a.distance_m) : null, clockTime(a.moving_s)].filter(Boolean).join(' · ')}</span>
        </Link>
      {/if}
    {/if}
  {/if}
</div>
